function toggleCategories() {
    var other_categories = jQuery('#other_categories');
    var other_categories_browse_button = jQuery('#other_categories_browse_button');

    if (other_categories.is(":visible")) {
        other_categories.hide();
        other_categories_browse_button.addClass('other_categories_browse_button_flipped');
    } else {
        other_categories.show();
        other_categories_browse_button.removeClass('other_categories_browse_button_flipped');
    }
}

jQuery('.other_categories_browse_button').click(function () {
    toggleCategories();
});

jQuery('#other_cat_switcher').click((e) => {
    jQuery('#other_cat_switcher').toggleClass('active');
    jQuery('.other_categories_wrapper').parent().parent().toggleClass('hidden');

});


jQuery('.clear_category_search').click(function (e) {
    e.preventDefault();
    jQuery('.hidden-result').removeClass('hidden-result');
    jQuery('.other_category.active').removeClass('active');
    jQuery(this).hide();
});

jQuery('#medication-category').click(function(e) {
    e.preventDefault();
    jQuery('.search_form>button').show();
    jQuery('html, body').animate({
        scrollTop: jQuery(".search_banner_container>.search_banner_sub_heading").offset().top
    }, 1500);
});

function startMedicationPopUp() {
    jQuery("#medicationPopUp").show();
    jQuery("#mainMedicationPopup").show();
};

function medicationHidePopUp() {
    jQuery('.popup_container:visible input').val('');
    jQuery('.popup_container:visible .search_bar_notice').hide();
    jQuery("#mainMedicationPopup").hide();
    jQuery("#medicationPopUp").hide();
    jQuery('#medicationContentButtons').hide();
    jQuery('#requestMedicationOnMedicationPopUp').hide();
};

function yesMedicationPopup() {
    jQuery('.popup_container:visible .large').removeClass('disabled');
    jQuery("#mainMedicationPopup").hide();
    jQuery('#yesMedicationPopup').show();
}

function yesMedicationPopupHide () {
    jQuery('.popup_container:visible input').val('');
    jQuery('.popup_container:visible .search_bar_notice').hide();
    jQuery('#medicationContentButtons').hide();
    jQuery("#yesMedicationPopup").hide();
    jQuery("#medicationPopUp").hide();
}

function noMedicationPopup() {
    jQuery("#mainMedicationPopup").hide();
    jQuery('#noMedicationPopup').show();
}

function noMedicationPopupHide () {
    jQuery('.popup_container:visible input').val('');
    jQuery('.popup_container:visible .search_bar_notice').hide();
    jQuery('#medicationContentButtons').hide();
    jQuery("#noMedicationPopup").hide();
    jQuery("#medicationPopUp").hide();
}